import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Button,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { format } from "date-fns";
import { useSnackbar } from "notistack";

const MilkingFormModal = ({
  open,
  onClose,
  initialValues,
  onSubmit,
  title = "Add Milking Record",
}) => {
  const isEdit = Boolean(initialValues?.id);
  const [dateValue, setDateValue] = useState(
    initialValues?.date ? new Date(initialValues.date) : new Date()
  );
  const [morning, setMorning] = useState(
    initialValues?.morning_production ?? 0
  );
  const [evening, setEvening] = useState(
    initialValues?.evening_production ?? 0
  );
  const [saving, setSaving] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (open) {
      setDateValue(
        initialValues?.date ? new Date(initialValues.date) : new Date()
      );
      setMorning(initialValues?.morning_production ?? 0);
      setEvening(initialValues?.evening_production ?? 0);
    }
  }, [open, initialValues]);

  const getErrMsg = (e) =>
    e?.response?.data?.detail ||
    e?.detail ||
    e?.message ||
    (typeof e === "string" ? e : "Operation failed");

  const handleSubmit = async () => {
    const payload = {
      date: format(dateValue, "yyyy-MM-dd"),
      morning_production: Number(morning || 0),
      evening_production: Number(evening || 0),
    };

    setSaving(true);
    try {
      await onSubmit(payload); // parent returns a Promise
      enqueueSnackbar(
        isEdit ? "Milking record updated" : "Milking record created",
        { variant: "success" }
      );
      onClose(); // close after success
    } catch (e) {
      enqueueSnackbar(getErrMsg(e), { variant: "error" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => !saving && onClose()}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>{isEdit ? "Edit Milking Record" : title}</DialogTitle>
      <DialogContent dividers>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
            gap: 2,
            mt: 1,
          }}
        >
          <DatePicker
            label="Date"
            value={dateValue}
            onChange={(v) => v && setDateValue(v)}
            slotProps={{ textField: { fullWidth: true } }}
          />
          <TextField
            type="number"
            label="Morning (L)"
            value={morning}
            onChange={(e) => setMorning(e.target.value)}
            fullWidth
            inputProps={{ min: 0, step: "0.1" }}
          />
          <TextField
            type="number"
            label="Evening (L)"
            value={evening}
            onChange={(e) => setEvening(e.target.value)}
            fullWidth
            inputProps={{ min: 0, step: "0.1" }}
          />
          <TextField
            label="Total (L)"
            value={(Number(morning || 0) + Number(evening || 0)).toFixed(1)}
            InputProps={{ readOnly: true }}
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button disabled={saving} onClick={onClose}>
          Cancel
        </Button>
        <Button disabled={saving} onClick={handleSubmit} variant="contained">
          {isEdit ? "Save Changes" : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MilkingFormModal;
